import store from "../../store";

// Services Imports
import {
  fetchKanbanDocsService,
  updateDocumentStatusService,
} from "./kanbanServices";

// Methods Imports
import { prepareKanbanData, reArrangeKanbanDocs } from "./kanbanMethods";

export const getAllKanbanDocs = () => dispatch =>
  new Promise((resolve, reject) => {
    fetchKanbanDocsService()
      .then(response => {
        dispatch({
          type: "KANBAN_DOCS",
          payload: prepareKanbanData(response),
        });
        dispatch({
          type: "ALL_DOCS",
          payload: response,
        });
        resolve(response);
      })
      .catch(error => {
        console.error(`kanbanActionss => getAllKanbanDocs => ${error}`);
        reject(error);
      });
  });

export const updateDocumentStatus =
  (newStatus, oldStatus, docID, newStatusID) => dispatch =>
    new Promise((resolve, reject) => {
      const { kanbanDocs } = store.getState().KanbanStore;
      dispatch({
        type: "KANBAN_DOCS",
        payload: reArrangeKanbanDocs(newStatus, oldStatus, docID, newStatusID),
      });
      updateDocumentStatusService(docID, newStatusID)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          dispatch({
            type: "KANBAN_DOCS",
            payload: kanbanDocs,
          });
          reject(err);
        });
    });

export const updateKanbanSearchTerm = searchTerm => dispatch => {
  const { allDocs } = store.getState().KanbanStore;
  dispatch({
    type: "KANBAN_SEARCH_TERM",
    payload: searchTerm,
  });
  dispatch({
    type: "KANBAN_DOCS",
    payload:
      searchTerm.length > 0
        ? prepareKanbanData(
            allDocs.filter(doc =>
              `${doc.doc_no}${doc.title}`
                .toLowerCase()
                .includes(searchTerm.toLowerCase()),
            ),
          )
        : prepareKanbanData(allDocs),
  });
};
